import { WorkspaceType } from '../../types'

export const getWorkspaceById = (_id?: string, workspaces?: WorkspaceType[]) => {
  return workspaces?.find((w) => w._id === _id)
}
